import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  Form,
  Icon,
  ICONS,
  RadioInput,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS, PROTECTED_PERMISSION_GROUPS } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

import { IViewDetailsProps } from './view-details.interfaces';
import { ViewDetailsContainer, IconContainer } from './view-details.styles';

const ViewDetails: FC<IViewDetailsProps> = ({ record, removeGroup }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('settings');
  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: record.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.permissionGroup,
  });

  return (
    <ViewDetailsContainer>
      <Form layout="vertical">
        {record.permissions.map(({ permission, rule }: any) => (
          <Form.Item
            key={permission}
            label={t(`permissionGroupSettings.yuuHrPermissions.${permission}`)}
          >
            <RadioInput disabled checked>
              {t(`permissionGroupSettings.rules.${rule}`)}
            </RadioInput>
          </Form.Item>
        ))}
      </Form>
      <IconContainer canDelete>
        {canEdit && (
          <Icon
            icon={ICONS.editAlt}
            size={22}
            color={PLATFORM_THEME_COLORS.primary.grey}
            onClick={() =>
              navigate({
                pathname: `${ROUTES.settings}?type=${SETTINGS_PAGES.permissionGroupsEdit}&id=${record._id}`,
              })
            }
          />
        )}
        {!PROTECTED_PERMISSION_GROUPS.some(
          name => name.toLowerCase() === record.name.toLowerCase()
        ) &&
          canDelete && (
            <Icon
              icon={ICONS.trash}
              color={PLATFORM_THEME_COLORS.tone.red}
              size={22}
              onClick={() => removeGroup(record._id)}
            />
          )}
      </IconContainer>
    </ViewDetailsContainer>
  );
};

export default ViewDetails;
